import { createStoreManager } from '@tob/shared/redux';
import { config } from '@shopee-user/platform';

const { DEV, IS_LOCAL } = config;

const isDevMode = !!(DEV || IS_LOCAL);

export const storeManager = createStoreManager({
  reducersMapObj: {},
  enhancers: [],
  // Redux DevTools should be disabled in the production build for two reasons:
  // 1. To prevent users from inspecting or tampering with the application's state and code.
  // 2. To avoid potential side effects on code execution, ensuring reliable behavior in the live environment.
  devTools: isDevMode,
});

export const store = storeManager.store;
export const injectReducer = storeManager.injectReducer;
